class ArtistDirectory extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  get letterButtons() {
    return Array.from(this.querySelectorAll('.artist-directory__letter'));
  }

  get items() {
    return Array.from(this.querySelectorAll('.artist-menu-item'));
  }

  onClick = (event) => {
    const button = event.target.closest('.artist-directory__letter');

    if (!button || button.disabled) {
      return;
    }

    this.filter(button.dataset.letter);
  };

  filter(letter) {
    this.letterButtons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.letter === letter ? 'true' : 'false'));
    this.items.forEach((item) => (item.hidden = letter !== 'all' && item.dataset.letter !== letter));
    this.toggleAttribute('filtered', letter !== 'all');
  }
}

class ArtistsMegaMenu extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  get tabs() {
    return Array.from(this.querySelectorAll('[role="tab"]'));
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');

    if (tab) {
      this.select(tab);
      return;
    }

    if (event.target.closest('[data-action="close-artists-menu"]')) {
      this.closest('mega-menu-disclosure')?.close();
    }
  };

  select(selectedTab) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !isSelected;
    });
  }
}

if (!window.customElements.get('artist-directory')) {
  window.customElements.define('artist-directory', ArtistDirectory);
}

if (!window.customElements.get('artists-mega-menu')) {
  window.customElements.define('artists-mega-menu', ArtistsMegaMenu);
}
